export default function NumberWithCommas(num?: any, digit?: number) {
    if (num) {
        num = num.toFixed(digit ? digit : 0).toString();
        const pattern = /(-?\d+)(\d{3})/;
        while (pattern.test(num))
            num = num.replace(pattern, "$1,$2");
        return num;
    }
    return 0;
}